import moment from "@/utils/moment";
import accountHelper from "@/utils/helpers/account";

const profilePicture = professional => {
  return accountHelper.profilePicture(professional.account);
};

const fullName = professional => {
  return accountHelper.fullName(professional.account);
};

const shorterFullName = professional => {
  return accountHelper.shorterFullName(professional.account);
};

const firstName = professional => {
  return accountHelper.firstName(professional.account);
};

const orderCount = professional => {
  return professional.completed_orders_count;
};

const minOrderCount = totalOrders => {
  return totalOrders < 5 ? "< 5" : totalOrders;
};

const accountCreation = professional => {
  return moment(professional.account.created_at).format("MMM/YYYY");
};

const rating = professional => {
  if (professional.total_feedbacks_count < 3) return "Novo(a)";

  return (professional.rating / 2000.0).toFixed(1);
};

const coupon = professional => {
  return professional.active_coupon;
};

const bio = professional => {
  return professional.account.profile.bio;
};

const feedbacks = professional => {
  return professional.total_feedbacks_count;
};

const latestFeedback = professional => {
  return professional.latest_feedback;
};

const topProfessional = professional => {
  if (!professional.professional_rating) return false;

  return professional.professional_rating.is_top_professional;
};

const highDemand = professional => {
  if (!professional.professional_rating) return false;

  return professional.professional_rating.in_high_demand;
};

export default {
  filters: {
    profilePicture,
    fullName,
    shorterFullName,
    firstName,
    orderCount,
    minOrderCount,
    accountCreation,
    rating,
    coupon,
    bio,
    feedbacks,
    topProfessional,
    highDemand,
    latestFeedback
  }
};



// WEBPACK FOOTER //
// ./src/mixins/accountable/professionalMixin.js